var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue2-org-tree',{attrs:{"data":_vm.treeData,"collapsable":"","render-content":_vm.renderContent},on:{"on-expand":_vm.onExpand,"on-node-click":_vm.NodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }